import React from 'react';
import ProductImages from './../ProductDetail/ProductImages';
import { useDispatch, useSelector } from 'react-redux';
import { FastField, Form, Formik } from 'formik';
import { trackEvent } from '../../components/Tracking/Matomo';
import { addReifen } from '../../../modules/actions/standort/session/cart';
import Currency from '../../../helpers/currency';
import { taxLabel } from '../../../helpers/taxHelper';
import { speedIndexToSpeed } from '../../../helpers/tiresHelper';
import Button from '../../components/form-elements/Button';
import TireInformationModal from '../../components/Tires/TireInformationModal';
import TireEnergyLabelLinks from '../Tires/TireEnergyLabelLinks';
import Anchor from '../../components/form-elements/Anchor';
import LegacyTireLabel from '../../components/Tires/LegacyTireLabel';
import { InternalLink } from '../../components/form-elements/Link';
import { markenStandortSelector } from '../../../modules/selectors/standort/markenStandort';


function QuantityBox({ tire, online: isOnline, lieferweg, price }) {
    const dispatch = useDispatch();

    function handleSubmit({ quantity }) {
        trackEvent({
            category: 'E-Commerce',
            action: 'Lege-in-Warenkorb',
            label: tire.neutralKey,
            value: price * quantity * 100,
        });
        dispatch(
            addReifen({
                reifen: {
                    ...tire,
                    selectedLieferweg: lieferweg,
                    selectedBezugsquelle: {
                        ...tire.selectedBezugsquelle,
                        vk_preis: price,
                    },
                },
                quantity,
            })
        );
    }

    return (
        <Formik
            initialValues={{ quantity: 1 }}
            onSubmit={handleSubmit}
            render={({ values }) => (
                <Form>
                    <div className="uk-background-muted uk-padding" data-uk-margin="">
                        <div className="uk-grid-small uk-flex-middle" data-uk-grid="">
                            <div className="uk-width-1-1 uk-width-1-3@l">
                                <div className="uk-text-center">
                                    <h2 className="aps-price">
                                        <Currency quantity={price * values.quantity} />
                                    </h2>
                                    <div className="uk-text-small uk-text-muted">
                                        <div>Preis inkl. {taxLabel()} MwSt.</div>
                                        {isOnline && (
                                            <div>
                                                zzgl. etwaiger <InternalLink to="/versandkosten" ariaLabel="Informationen zu Versandkosten"><u>Versandkosten</u></InternalLink>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="uk-width-1-1 uk-width-1-3@l">
                                <div className="uk-flex uk-flex-column uk-flex-middle uk-flex-left@l">
                                    <div className="uk-grid-small uk-flex-middle" data-uk-grid="">
                                        <label className="uk-form-label" htmlFor="quantity">
                                            Menge
                                        </label>
                                        <div className="uk-form-controls">
                                            <FastField className="uk-input" name="quantity" type="number" min={1} max={1000} aria-label="Menge festlegen, Minimum: 1 Maximum: 1000"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="uk-width-1-1 uk-width-1-3@l uk-flex uk-flex-center">
                                <div>
                                    <Button type="submit" ariaLabel={isOnline ? 'Zum Warenkorb hinzufügen' : 'RESERVIEREN & ABHOLEN'}>{isOnline ? 'Zum Warenkorb hinzufügen' : 'RESERVIEREN & ABHOLEN'}</Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Form>
            )}
        />
    );
}


function MerklistenTireDetail({ tireDetail }) {
    const markenStandort = useSelector(markenStandortSelector);
    const to = tireDetail.href || `/${tireDetail.categories[0]}/${tireDetail.id || tireDetail.neutralKey}`;

    const additionalInformation = tireDetail?.additionalInfo?.dotWare
        ? { label: `DOT: ${tireDetail.additionalInfo.dotWare}`, tooltip: 'DOT = Herstellungsjahr des Reifens' }
        : tireDetail?.additionalInfo?.herstellerGarantie
            ? { label: 'mit Herstellergarantie', tooltip: 'Spezielle Garantie des Herstellers' }
            : tireDetail?.additionalInfo?.demo
                ? {
                    label: 'DEMO-Reifen',
                    tooltip:
                        'Demontierte Reifen bis Max. 50km Laufleistung von Vorführ- oder Neufahrzeugen bzw. von Kompletträdern zur Winter/Sommer Saison',
                }
                : undefined;

    return (
        <>
            <div className='uk-section uk-section-default uk-section-small'>
                <div className="uk-container uk-margin-medium-top">
                    <InternalLink to={to}>
                        <h1 className="uk-margin-remove uk-text-left">
                            {tireDetail.hersteller} {tireDetail.profil} <span className="uk-text-muted">{tireDetail.bezeichnung}</span>
                        </h1>
                    </InternalLink>
                    <h2 className="uk-text-light uk-margin-remove uk-text-left">{tireDetail.warengruppe}</h2>
                    <p className='uk-text-left'>Artikelnummer: {tireDetail.selectedBezugsquelle.artNummer}</p>
                    <div className="uk-grid-small uk-child-width-1-2@s" data-uk-grid="">
                        <ProductImages variant={tireDetail} images={tireDetail.images || []} linkedTo={to}/>
                        <div>
                            <div className="uk-child-width-1-1 uk-grid-small" data-uk-grid="">
                                {tireDetail.onlineLieferweg && (
                                    <QuantityBox
                                        addReifen={addReifen}
                                        tire={tireDetail}
                                        price={tireDetail.selectedBezugsquelle.onlineVK}
                                        lieferweg={tireDetail.onlineLieferweg}
                                        online
                                    />
                                )}
                                {tireDetail.pickupLieferweg && !markenStandort.isTechno && (
                                    <QuantityBox
                                        addReifen={addReifen}
                                        tire={tireDetail}
                                        price={tireDetail.selectedBezugsquelle.vk_preis}
                                        lieferweg={tireDetail.pickupLieferweg}
                                    />
                                )}
                                {tireDetail.energyLabelUrl && (
                                    <div>
                                        <div className="uk-margin-small-bottom uk-text-left">
                                            <TireInformationModal tire={tireDetail} />
                                        </div>
                                        <div data-uk-grid="" className="uk-grid-small uk-child-width-expand@s uk-text-left">
                                            <TireEnergyLabelLinks tire={tireDetail} />
                                        </div>
                                    </div>
                                )}
                                <div>
                                    <table className="uk-table uk-table-striped uk-table-small uk-text-left">
                                        <tbody>
                                            <tr>
                                                <td>Hersteller</td>
                                                <td>{tireDetail.hersteller}</td>
                                            </tr>
                                            <tr>
                                                <td>Profil</td>
                                                <td>{tireDetail.profil}</td>
                                            </tr>
                                            <tr>
                                                <td>Größe</td>
                                                <td>{tireDetail.bezeichnung}</td>
                                            </tr>
                                            <tr>
                                                <td>Geschwindigkeitsindex</td>
                                                <td>
                                                    {tireDetail.speedindex} bis {speedIndexToSpeed[tireDetail.speedindex]} km/h
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Loadindex</td>
                                                <td>{tireDetail.loadindex}</td>
                                            </tr>
                                            <tr>
                                                <td>Kategorie</td>
                                                <td>{tireDetail.warengruppe}</td>
                                            </tr>
                                            <tr>
                                                <td>Zusatzinformationen</td>
                                                <td>
                                                    {additionalInformation && (
                                                        <div data-uk-tooltip={additionalInformation.tooltip}>
                                                            <i className="fa fa-info-circle" aria-hidden="true" />{' '}
                                                            {additionalInformation.label}
                                                        </div>
                                                    )}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>DEMO-Reifen</td>
                                                <td>
                                                    {tireDetail?.additionalInfo?.demo ? 'Ja' : 'Nein'}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <p className="uk-text-muted uk-text-left">Lieferung ohne Felge</p>
                                </div>
                                <div>
                                    {!tireDetail.energyLabelUrl && (
                                        <ul data-uk-accordion="">
                                            <li className="uk-open">
                                                <Anchor className="uk-accordion-title">EU-Reifenlabel</Anchor>
                                                <div className="uk-accordion-content">
                                                    <LegacyTireLabel tireDetails={tireDetail} />
                                                </div>
                                            </li>
                                        </ul>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}


export default MerklistenTireDetail;